define('flight-components/mixins/withToggle',[], function() {

  var withToggle = function withToggle() {

    this.defaultAttrs({
      'isActive': false,
      'toggleSelector': '[data-toggle]'
    });

    this.toggleState = function() {
      this.attr.isActive = !this.attr.isActive;
      
      this.select('toggleSelector').data('toggleActive', this.attr.isActive);
      this.trigger('toggleStateChanged', {isActive: this.attr.isActive});
    };

    this.after('initialize', function() {

      this.attr.isActive = this.select('toggleSelector').data('toggleActive') || false;

      this.on('click', {
        'toggleSelector': this.toggleState
      });

    });

  };

  return withToggle;

});
